import i18n from '@/i18n.js'

import {
  UI_SHOW_SIDEBAR,
  UI_CLOSE_SIDEBAR,
  UI_ENABLE_MOVE_BOOK_MODE,
  UI_DISABLE_MOVE_BOOK_MODE,
  UI_SELECT_BOOK,
  UI_UNSELECT_BOOK,
  UI_UNSELECT_ALL_BOOKS
} from '@/store/types'

const state = {
  showSidebar: false,
  moveBookModeEnabled: false,
  selectedBooks: [],
  currency: ''
}

const getters = {
  isSidebarOpen: (state) => state.showSidebar,
  isMoveBookModeEnabled: (state) => state.moveBookModeEnabled,
  getSelectedLibraryBooks: (state) => state.selectedBooks,
  getLang: () => {
    let activeLang = i18n.locale
    return activeLang
  },
  getCurrency: (state) => {
    let activeLang = i18n.locale
    let currency = {
      mode: ['html_inicis'],
      currency: 'KRW',
      paypalCd: 'kr',
      localeCd: 'ko'
    }

    switch (activeLang) {
      case 'en':
        currency = {
          mode: ['paypal', 'html_inicis', 'eximbay'],
          // mode: ['paypal', 'html_inicis'],
          currency: 'USD',
          paypalCd: 'us',
          localeCd: 'en'
        }
        break
      case 'ko' | '':
        currency = {
          mode: ['html_inicis'],
          currency: 'KRW',
          paypalCd: 'kr',
          localeCd: 'ko'
        }
        break
      case 'ja':
        currency = {
          mode: ['paypal', 'eximbay'],
          // mode: ['paypal'],
          currency: 'JPY',
          paypalCd: 'jp',
          localeCd: 'jp'
        }
        break
      case 'es' || 'fr' || 'it':
        currency = {
          mode: ['paypal', 'eximbay'],
          // mode: ['paypal'],
          currency: 'EUR',
          paypalCd: 'es',
          localeCd: 'es'
        }
        break
      case 'zh':
        currency = {
          mode: ['paypal'],
          currency: 'USD',
          paypalCd: 'us',
          localeCd: 'en'
          // currency: 'CNY',
          // paypalCd: 'cn',
          // localeCd: 'zh'
        }
        break
      case 'ru':
        currency = {
          mode: ['paypal'],
          currency: 'RUR',
          paypalCd: 'ru',
          localeCd: 'ru'
        }
        break
    }
    state.currency = currency
    return state.currency
  }
}

const actions = {}

const mutations = {
  [UI_SHOW_SIDEBAR]: (state) => {
    state.showSidebar = true
  },
  [UI_CLOSE_SIDEBAR]: (state) => {
    state.showSidebar = false
  },
  [UI_ENABLE_MOVE_BOOK_MODE]: (state) => {
    state.moveBookModeEnabled = true
  },
  [UI_DISABLE_MOVE_BOOK_MODE]: (state) => {
    state.moveBookModeEnabled = false
  },
  [UI_SELECT_BOOK]: (state, id) => {
    if (!state.selectedBooks.includes(id)) {
      state.selectedBooks = [...state.selectedBooks, id]
    }
  },
  [UI_UNSELECT_BOOK]: (state, id) => {
    state.selectedBooks = state.selectedBooks.filter((b) => b !== id)
  },
  [UI_UNSELECT_ALL_BOOKS]: (state) => {
    state.selectedBooks = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
